import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_eraser.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconEraser = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconEraser;
